// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2002":"5bc02827","2201":"caa83089","2245":"caa83089","5409":"25ed76d7","6283":"25ed76d7"}[chunkId] + ".chunk.css";
};